// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"e601e6d8","703":"3590f5d2","787":"f01272e9"}[chunkId] + ".chunk.js";
};